import { useMemo } from "react";
import Icon2 from "../assets/cardIcons/2.svg";
import Icon3 from "../assets/cardIcons/3.svg";
import Icon4 from "../assets/cardIcons/4.svg";
import Icon5 from "../assets/cardIcons/5.svg";
import Icon6 from "../assets/cardIcons/6.svg";
import Icon8 from "../assets/cardIcons/8.svg";

const defaultIcons = [Icon2, Icon3, Icon4, Icon5, Icon6, Icon8];

const useRandomIcon = (icons) => {
  const iconList = icons && icons.length > 0 ? icons : defaultIcons;

  return useMemo(() => {
    return () => iconList[Math.floor(Math.random() * iconList.length)];
  }, [iconList]);
};

export default useRandomIcon;
